import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class GetLessonCategoriesList extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("LessonCategory/GetList");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class CreateNewLessonCategory extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("LessonCategory/Create");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class UpdateALessonCategory extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("LessonCategory/Update");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetLessonCategoryById extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("LessonCategory/GetById");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class DeleteLessonCategory extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("LessonCategory/Delete");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class ToggleLessonCategoryIsShow extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("LessonCategory/ToggleIsShow");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetLiteLessonCategories extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("LessonCategory/GetLightList");
  }
}


class GetAllUserBoughtPackages extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("LessonCategory/BoughtPackageOfUserId");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class CreateOrderByAdmin extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("LessonCategory/CreateOrderByAdmin");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

export {
  GetLessonCategoriesList,
  CreateNewLessonCategory,
  GetLessonCategoryById,
  UpdateALessonCategory,
  DeleteLessonCategory,
  ToggleLessonCategoryIsShow,
  GetLiteLessonCategories,
  GetAllUserBoughtPackages,
  CreateOrderByAdmin
};
